// extracted by mini-css-extract-plugin
export default {"vip-badge":"vip-badge_LHvAt","vipBadge":"vip-badge_LHvAt","max":"max_Sk8rq","ultra":"ultra_gfMQ3"};